import axios from 'axios';

const baseUrl = () => {
  const port = 443;
  const scheme = `http${port === 443 ? 's' : ''}`;
  return `${scheme}://public-rest42.bullhornstaffing.com:${port}/rest-services/5Z5MO4/apply`;
};

const assembleParams = data => {
  let params = [];
  params.push(`externalID=Resume`);
  params.push(`type=Resume`);
  for (let key in data) {
    if (!data.hasOwnProperty(key)) {
      continue;
    }
    if (!data[key]) {
      continue;
    }
    const value = data[key];
    params.push(`${key}=${value}`);
  }
  return params.join('&');
};

const jobPostData = (id, params, formData) => {
  const applyParams = assembleParams(params);
  return axios.post(`${baseUrl()}/${id}/raw?${applyParams}`, formData);
};

export default jobPostData;
